module.exports = __webpack_public_path__ + "img/distance.6581bab2.svg";